import { useTranslation } from 'react-i18next'
import { Section } from '../ui/Section'
import { Container } from '../ui/Container'
import { SectionTitle } from '../ui/SectionTitle'
import { MapPin, Phone, Mail, FileText, Clock } from 'lucide-react'

export function ContactInfo() {
  const { t } = useTranslation()

  return (
    <Section>
      <Container>
        <SectionTitle title={t('contacts.info.title')} />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Address */}
          <div className="flex items-start gap-4 p-6 bg-primary/5 rounded-lg">
            <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
              <MapPin className="w-6 h-6 text-dark" />
            </div>
            <div>
              <h3 className="font-semibold text-dark mb-1">
                {t('contacts.info.address')}
              </h3>
              <p className="text-gray-600">{t('contact.address')}</p>
              <p className="text-gray-600">{t('contact.city')}</p>
            </div>
          </div>

          {/* Phone */}
          <div className="flex items-start gap-4 p-6 bg-primary/5 rounded-lg">
            <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
              <Phone className="w-6 h-6 text-dark" />
            </div>
            <div>
              <h3 className="font-semibold text-dark mb-1">
                {t('contacts.info.phone')}
              </h3>
              <a
                href={`tel:${t('contact.phone').replace(/\s/g, '')}`}
                className="text-gray-600 hover:text-primary transition-colors"
              >
                {t('contact.phone')}
              </a>
            </div>
          </div>

          {/* Email */}
          <div className="flex items-start gap-4 p-6 bg-primary/5 rounded-lg">
            <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
              <Mail className="w-6 h-6 text-dark" />
            </div>
            <div>
              <h3 className="font-semibold text-dark mb-1">
                {t('contacts.info.email')}
              </h3>
              <a
                href={`mailto:${t('contact.email')}`}
                className="text-gray-600 hover:text-primary transition-colors"
              >
                {t('contact.email')}
              </a>
            </div>
          </div>

          {/* PEC */}
          <div className="flex items-start gap-4 p-6 bg-primary/5 rounded-lg">
            <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
              <FileText className="w-6 h-6 text-dark" />
            </div>
            <div>
              <h3 className="font-semibold text-dark mb-1">
                {t('contacts.info.pec')}
              </h3>
              <a
                href={`mailto:${t('contact.pec')}`}
                className="text-gray-600 hover:text-primary transition-colors"
              >
                {t('contact.pec')}
              </a>
            </div>
          </div>

          {/* Hours */}
          <div className="flex items-start gap-4 p-6 bg-primary/5 rounded-lg md:col-span-2 lg:col-span-2">
            <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
              <Clock className="w-6 h-6 text-dark" />
            </div>
            <div>
              <h3 className="font-semibold text-dark mb-1">
                {t('contacts.info.hours')}
              </h3>
              <p className="text-gray-600">{t('contacts.info.weekdays')}</p>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  )
}
